import React from 'react';
import { Button, ButtonProps, Modal, ModalVariant } from '@patternfly/react-core';

interface ConfirmationModalProps {
    isOpen: boolean,
    title?: string,
    onConfirm: () => void,
    onClose: () => void,
    variant?: ModalVariant,
    confirmLabel?: string,
    cancelLabel?: string,
    confirmVariant?: ButtonProps['variant'];
}

const ConfirmationModal = (props: React.PropsWithChildren<ConfirmationModalProps>) => {
    const { isOpen, title, onClose, variant, confirmLabel, cancelLabel, onConfirm, confirmVariant, children } = props;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            variant={variant || ModalVariant.default}
            title={title}
            actions={[
                <Button data-test='modal-button' data-testid='confirm' key="confirm" variant={confirmVariant || 'primary'} onClick={onConfirm}>{confirmLabel || 'OK'}</Button>,
                <Button data-test='modal-button' data-testid='cancel' key="cancel" variant="secondary" onClick={onClose}>{cancelLabel || 'Cancel'}</Button>
            ]}
        >
            {children}
        </Modal>
    );
}

export default ConfirmationModal;
